var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgGreenChecked = function SvgGreenChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 11.083c-30.59 0-55.417 24.827-55.417 55.417S35.91 121.917 66.5 121.917 121.916 97.09 121.916 66.5 97.09 11.083 66.5 11.083zM55.416 94.208L27.708 66.5l7.814-7.814 19.894 19.84 42.062-42.062 7.813 7.87-49.875 49.874z",
    fill: "#3CC13B"
  })));
};
export default SvgGreenChecked;